module.exports = __webpack_public_path__ + "img/icon-style-bg-no-rounded.f309a40.png";